import React, { useEffect, useState, useRef } from 'react';

import styles from "./Landing.module.css";
import Header from '../../Components/Header/Header';
import Footer from '../../Components/Footer/Footer';
import HomeIcon from "../../assets/Frame 165.png";
import PIcon from "../../assets/Frame 165 (1).png";
import SIcon from "../../assets/Frame 165 (2).png";
import Icon1 from "../../assets/reg.png";
import Icon2 from "../../assets/ben.png";
import Icon3 from "../../assets/lga.png";
import Icon4 from "../../assets/ver.png";
import About1 from "../../assets/abt1.svg";
import About2 from "../../assets/abt2.svg";
import Bid1 from "../../assets/lnd.png";
import Bid2 from "../../assets/bid2.jpg";
import Bid3 from "../../assets/bid3.jpg";
import Bid4 from "../../assets/bid4.jpg";
import News1 from "../../assets/pro (1).jpg";
import News2 from "../../assets/pro (2).jpg";
import News3 from "../../assets/pro (3).jpg";
import Name1 from "../../assets/nam1.svg";
import RegistryIcon from "../../assets/registryy.svg";
import Name2 from "../../assets/nam2.svg";
import Name3 from "../../assets/nam3.svg";
import Miss1 from "../../assets/mis1.svg";
import Miss2 from "../../assets/mis2.svg";
import Miss3 from "../../assets/mis3.svg";
import Location from "../../assets/location.svg";
import Mail from "../../assets/mail.svg";
import Call from "../../assets/call.svg";
import LandingImage from "../../assets/lnds.png";
import { FiSearch } from "react-icons/fi";
import ProcureIcon from "../../assets/procure.svg";
import MissionIcon from "../../assets/mission.svg";
import LandingPage from "../../assets/land.png";
import UnderlineIcon from "../../assets/underline.png";
import Upicon from "../../assets/arrow-circle-broken-up-right.svg";
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import HomeIconHover from "../../assets/building-08 (1).png";
import PIconHover from "../../assets/user-03.png";
import SIconHover from "../../assets/check-verified-02.png";

import Charts from "../../assets/Chat.png"

/* Ellipsis svgs */
import ellipse1 from "../../assets/Ellipse 3 Center.svg";
import ellipse2 from "../../assets/Ellipse 1 left.svg";
import ellipse3 from "../../assets/Ellipse 2 Right.svg"
import ellipse4 from "../../assets/Ellipse 4 bottom.svg";
import BuildingIcon from "../../assets/building.png";

/* Top action icons */
import payTax from "../../assets/credit-card-02.svg";
import businessTax from "../../assets/building-08.svg";
import getTin from "../../assets/cryptocurrency-02.svg";
import taxClearance from "../../assets/certificate-02.svg";

/* Center icons */
import integrity from "../../assets/Frame 133.png";
import efficiency from "../../assets/Frame 233.png";
import verifyTin from "../../assets/verifytin.png";
import excellence from "../../assets/Frame 433.png";
import professionalism from "../../assets/Frame 533.png";

/* Bottom section icons */
import empower from "../../assets/Frame 13.png";
import trusted from "../../assets/Frame 13 (1).png";
import integrityService from "../../assets/Frame 13 (2).png";
import { NavLink, useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";



const placeholder = "Search tenders, contracts, or procurement opportunities...";


const Landing = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const handleSignUp = () => {
    navigate("/signup");
  };
  const handleAbout = () => {
    navigate("/about-us");
  };
const newsData = [
  {
    id: 1,
    category: "Procurement Notice",
    date: "22 Jan 2026",
    title: "Renovation of Public Health Facilities",
    description:
      "The Bureau invites qualified contractors to submit bids for renovation works.",
    image: News1,
  },
  {
    id: 2,
    category: "Public Announcements",
    date: "22 Jan 2026",
    title: "Public Procurement Awareness Programme",
    description:
      "An upcoming awareness programme aimed at improving compliance.",
    image: News2,
  },
  {
    id: 3,
    category: "platform",
    date: "18 Jan 2026",
    title: "New Vendor Registration Guidelines",
    description:
      "Updated guidelines for vendor onboarding and verification.",
    image: News3,
  },
  {
    id: 4,
    category: "platform",
    date: "18 Jan 2026",
    title: "New Vendor Registration Guidelines",
    description:
      "Updated guidelines for vendor onboarding and verification.",
    image: News3,
  },
  {
    id: 5,
    category: "platform",
    date: "18 Jan 2026",
    title: "New Vendor Registration Guidelines",
    description:
      "Updated guidelines for vendor onboarding and verification.",
    image: News3,
  },
];


const [text, setText] = useState(placeholder);
const [charIndex, setCharIndex] = useState(placeholder.length);
const [isDeleting, setIsDeleting] = useState(true);
const [activeTab, setActiveTab] = useState("adverts");
const [currentPage, setCurrentPage] = useState(1);
const itemsPerPage = 10;
const carouselRef = useRef(null);
const [currentIndex, setCurrentIndex] = useState(0);
const AUTO_SLIDE_DELAY = 5000;
const [activeNewsTab, setActiveNewsTab] = useState("all");
const [page, setPage] = useState({
  adverts: 1,
  awards: 1,
});

const adverts = [
  {
    id: 1,
    status: "Open",
    title: "Invitation For Bids (IFB) - Procurement of Health Commodities",
    description:
      "DRUG MANAGEMENT AGENCY has responsibility to procure, store and distribute medicines..."
  },
  {
    id: 2,
    status: "Open",
    title: "RE: Invitation for Prequalification by BPP",
    description:
      "The Ogun State Bureau of Public Procurement now invites Interested eligible applicants..."
  },
  {
    id: 3,
    status: "Open",
    title: "Advertisement for Prequalification to All Contractors",
    description:
      "The Ogun State Economic Transformation Project (OGSTEP) plans to construct feeder roads..."
  },
  // add more
];

const awards = [
  {
    id: 1,
    title: "Procurement Excellence Award",
    description:
      "Recognized for transparency and accountability in public procurement processes."
  },
  {
    id: 2,
    title: "Public Sector Integrity Award",
    description:
      "Honoured for consistent adherence to procurement best practices."
  },
  // add more
];

const filteredNews =
  activeNewsTab === "all"
    ? newsData
    : newsData.filter(
        item => item.category === activeNewsTab
      );
const scrollToIndex = (index) => {
  if (!carouselRef.current) return;

  const cardWidth =
    carouselRef.current.firstChild?.offsetWidth || 0;

  carouselRef.current.scrollTo({
    left: index * cardWidth,
    behavior: "smooth",
  });
};

useEffect(() => {
  const interval = setInterval(() => {
    setCurrentIndex(prev =>
      prev >= filteredNews.length - 1 ? 0 : prev + 1
    );
  }, AUTO_SLIDE_DELAY);

  return () => clearInterval(interval);
}, [filteredNews.length]);

useEffect(() => {
  scrollToIndex(currentIndex);
}, [currentIndex]);


const activeData = activeTab === "adverts" ? adverts : awards;

const startIndex = (currentPage - 1) * itemsPerPage;
const paginatedData = activeData.slice(
  startIndex,
  startIndex + itemsPerPage
);

const totalPages = Math.ceil(activeData.length / itemsPerPage);




useEffect(() => {
  const speed = isDeleting ? 40 : 80;

  const timeout = setTimeout(() => {
    if (isDeleting) {
      setText(placeholder.slice(0, charIndex - 1));
      setCharIndex((prev) => prev - 1);

      if (charIndex === 0) {
        setTimeout(() => setIsDeleting(false), 600);
      }
    } else {
      setText(placeholder.slice(0, charIndex + 1));
      setCharIndex((prev) => prev + 1);

      if (charIndex === placeholder.length) {
        setTimeout(() => setIsDeleting(true), 1500);
      }
    }
  }, speed);

  return () => clearTimeout(timeout);
}, [charIndex, isDeleting]);


function ProcurementAdverts({ data }) {
  return (
    <>
      {data.map(item => (
        <div key={item.id} className={styles.card}>
          <span className={styles.status}>{item.status}</span>
          <h4>{item.title}</h4>
          <p>{item.description}</p>
          <div className={styles.dwnlCont}>
            <button className={styles.downloadBtn}>
              Download Files
            </button>
          </div>
        </div>
      ))}
    </>
  );
}


function Awards({ data }) {
  return (
    <>
      {data.map(item => (
        <div key={item.id} className={styles.card}>
          <h4>{item.title}</h4>
          <p>{item.description}</p>
        </div>
      ))}
    </>
  );
}

useEffect(() => {
  if (!carouselRef.current) return;

  const cardWidth =
    carouselRef.current.firstChild?.offsetWidth || 0;

  let index = 0;

  const interval = setInterval(() => {
    index++;

    carouselRef.current.scrollTo({
      left: index * cardWidth,
      behavior: "smooth",
    });

    // reset when reaching the end
    if (index >= filteredNews.length - 3) {
      index = -1;
    }
  }, 5000);

  return () => clearInterval(interval);
}, [filteredNews]);
const handlePrev = () => {
  setCurrentIndex(prev =>
    prev === 0 ? filteredNews.length - 1 : prev - 1
  );
};

const handleNext = () => {
  setCurrentIndex(prev =>
    prev >= filteredNews.length - 1 ? 0 : prev + 1
  );
};


  return (
    <>
      <div className={styles.mains}>
        <div className={styles.landingBackground}>
        <Header />
        <div>

          <section id="home" className={styles.wrapper}>
            {/* ===== HERO TEXT ===== */}
            <h1 className={styles.title}>
              Reaching Every <span style={{ color: '#D97706' }}>Household</span><br /> in Ogun State
                          </h1>

                          <p className={styles.subtitle}>
              Connecting households to the welfare support they qualify for
            </p>


            {/* ===== GET STARTED ===== */}
            <div className={styles.getStartedDiv}>

               <button className={styles.getStarteds}>
                <span onClick={() => navigate('/login')}>Login</span>
              </button>

              <button className={styles.getStarted}>
                <span onClick={() => navigate('/signup')}>Register</span>
              </button>

             
              {/* <img src={ellipse2} alt="" className={styles.svgleft} /> */}
            </div>
            <div className={styles.searchCon}>
 <img src={LandingImage} alt="" className={styles.imgcards} />
            </div>
            <div className={styles.underInfo}>
            <div className={styles.underInfos}>
<img src={Icon1} alt="" className={styles.underInfoIcon} />
<div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-start' }}>
<h1 className={styles.underText}>45,512</h1>
<h1 className={styles.underTexts}>Households Registered</h1>
</div>
            </div>
            <div className={styles.underInfos}>
<img src={Icon2} alt="" className={styles.underInfoIcon} />
<div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-start' }}>
<h1 className={styles.underText}>187,204</h1>
<h1 className={styles.underTexts}>Beneficiaries Enrolled</h1>
</div>
            </div>
            <div className={styles.underInfos}>
<img src={Icon3} alt="" className={styles.underInfoIcon} />
<div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-start' }}>
<h1 className={styles.underText}>20 LGAs</h1>
<h1 className={styles.underTexts}>Full State Coverage</h1>
</div>
            </div>
            <div className={styles.underInfos}>
<img src={Icon4} alt="" className={styles.underInfoIcon} />
<div style={{ display: 'flex', flexDirection: 'column', textAlign: 'left' }}>
<h1 className={styles.underText}>90%</h1>
<h1 className={styles.underTexts}>Verification Rate</h1>
</div>
            </div>
            </div>


           

            {/* ===== EFFICIENT & TRANSPARENT SECTION ===== */}
          </section>
</div>
        </div>

<div className={styles.platformPlace}>
 <div className={styles.platformTimes}>
              <h1 className={styles.platformFont}><span style={{ color: '#D97706' }}>—</span> ABOUT US</h1>
              
            </div>
<div className={styles.abtCont}>
  <img src={About1} alt=""  />
  <img src={About2} alt=""  />
</div>
</div>

<div className={styles.platCont}>
        <div className={styles.platformTimesss}>
         <h1 className={styles.platformFont}><span style={{ color: '#D97706' }}>—</span> WHO IT’S FOR</h1>
          <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', gap: 14 }}>
            <h1 className={styles.platformFontssfs}><span style={{color: '#166534' }}>Built for citizens</span><br/>and the officers who serve them</h1>
            <h1 className={styles.platf}>Built for citizens who need support, and the government staff who deliver it</h1>
           
          </div>
        </div>
        <div className={styles.missionCards}>
          <img src={Name1} alt="" className={styles.imgcardss} />
          <img src={Name2} alt="" className={styles.imgcardss2} />
          <img src={Name3} alt="" className={styles.imgcardss3} />
        </div>
</div>

<div className={styles.workCont}>
        <div className={styles.platformTimesss}>
         <h1 className={styles.platformFont}><span style={{ color: '#D97706' }}>—</span> HOW IT WORKS</h1>
          <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', gap: 14 }}>
            <h1 className={styles.platformFontssfs}><span style={{color: '#166534' }}>From registration</span><br/>to verified beneficiary</h1>
            <h1 className={styles.platf}>A clear, step-by-step process ensures every eligible household is captured accurately and fairly</h1>
           
          </div>
        </div>
        <div className={styles.missionCards}>
          <img src={RegistryIcon} alt=""  style={{width: '95%'}}/>
        </div>
</div>


       
 

        <div className={styles.participateCont}>
        <div className={styles.participate}>
          <div className={styles.participate1}>

<h1 className={styles.participateText}>Is your household <span style={{ color: '#22C55E' }}>eligible  for support?</span></h1>
<p className={styles.participateTextTag}>Registration is free. It takes less than 10 minutes. You may qualify for government welfare assistance programmes</p>
          </div>
          <div className={styles.btnPart}>
<button className={styles.getStartedparticipate}>
              <span  >Register</span>
            </button>
<button className={styles.getStartedparticipates}>
              <span  >Login</span>
            </button>
            </div>
        </div>
        </div>

        <Footer />
      </div>
    </>
  );
};

export default Landing;
